import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, message } from "antd";
import SignatureCanvas from "react-signature-canvas";

export default function SignatureModal({ visible, onCancel, onSave, verificacionId, nombreFormato }) {
  const sigCanvas = useRef({});
  const [isEmpty, setIsEmpty] = useState(true);
  const [canvasDimensions, setCanvasDimensions] = useState({ width: 500, height: 500 });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        const size = Math.min(window.innerWidth - 48, window.innerHeight - 200);
        setCanvasDimensions({
          width: size,
          height: size,
        });
      } else {
        setCanvasDimensions({ width: 500, height: 500 });
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const clearSignature = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
  };

  const saveSignature = () => {
    if (sigCanvas.current.isEmpty()) {
      message.warning("Please provide a signature.");
      return;
    }
    const dataURL = sigCanvas.current.toDataURL("image/png");
    onSave(dataURL, verificacionId, nombreFormato);
    onCancel();
  };

  return (
    <Modal
      title={`Draw Signature for ${nombreFormato}`}
      visible={visible}
      onCancel={onCancel}
      width={isMobile ? "100%" : canvasDimensions.width + 48} // Canvas width + default modal padding
      style={{ top: isMobile ? 0 : "50%", transform: isMobile ? "none" : "translateY(-50%)" }}
      footer={[
        <Button key="clear" onClick={clearSignature}>
          Clear
        </Button>,
        <Button key="save" type="primary" onClick={saveSignature} disabled={isEmpty}>
          Save
        </Button>,
      ]}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{
            width: canvasDimensions.width,
            height: canvasDimensions.height,
            className: "sigCanvas",
          }}
          onBegin={() => setIsEmpty(false)}
        />
      </div>
      <style jsx>{`
        .sigCanvas {
          border: 1px solid #ccc;
          border-radius: 4px;
        }
      `}</style>
    </Modal>
  );
}
